import React from 'react';
import styled from 'styled-components';
import {CTAButton} from '../mixins';
import {DirectionIcon} from './Icons';

const StyledButton = styled.button`
 ${CTAButton};
 position: relative;
 cursor: pointer;
 display: flex;
 justify-content: center;
 align-items: center;
 
 svg {
  margin-right: 10px;
 }
 
`

const GetDirectionBtn = (props) => {

    const onClickHandler = () => {

        if (props.browserLat && props.browserLng) {
            window.open('https://maps.google.com/maps?saddr=' + props.browserLat + ',' + props.browserLng + '&daddr=' + props.lat + ',' + props.lng);
        }

        else {
            window.open('https://maps.google.com/maps?daddr=' + props.lat + ',' + props.lng);
        }
    };

    return (
        <StyledButton onClick={onClickHandler} id='continue-button'>
            {DirectionIcon}
            {props.children}
        </StyledButton>
    )
};

export default GetDirectionBtn;